import { createApp } from 'vue'
import EventPage from './Store.vue'
import { store } from '@/store'
import mitt from 'mitt'
import VTooltip from 'v-tooltip'
import Vue3TouchEvents from 'vue3-touch-events'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

const emitter = mitt()

const app = createApp(EventPage)
app.use(store).use(VTooltip).use(Vue3TouchEvents)
app.provide('emitter', emitter)
app.provide('isVieworder', false).provide('isRenderer', false).provide('isEvent', true).provide('isStore', true)

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    app,
    dsn: 'https://5f312547c6614c60b09cd8cfaed998c6@o444341.ingest.sentry.io/5994377',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0
  })
}

app.mount('#app')